// extracted by mini-css-extract-plugin
module.exports =  {"folder":"_93444fe79c--folder--dHNi9","text":"_93444fe79c--text--nlEqt"};